import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Zap, ShoppingCart, Utensils, Map, LifeBuoy, Coffee, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
interface DeliverableItem {
  icon: React.ReactNode;
  title: string;
  desc: string;
  value: string;
  isBonus?: boolean;
}
const items: DeliverableItem[] = [{
  icon: <BookOpen className="w-6 h-6" strokeWidth={1.75} data-id="element-34" />,
  title: 'Guía Aplicada a Chile',
  desc: 'Plan Antinflamatorio 15-Min: Edición Chile',
  value: '$9.990'
}, {
  icon: <Zap className="w-6 h-6" strokeWidth={1.75} data-id="element-35" />,
  title: 'Protocolo Reset 72h',
  desc: 'Deshinchazón express antes de cualquier evento',
  value: '$5.990'
}, {
  icon: <ShoppingCart className="w-6 h-6" strokeWidth={1.75} data-id="element-36" />,
  title: 'Lista de Compras Zero Estrés',
  desc: 'Qué comprar exactamente en Líder, Jumbo o feria',
  value: '$3.990'
}, {
  icon: <Utensils className="w-6 h-6" strokeWidth={1.75} data-id="element-37" />,
  title: 'Recetario Express',
  desc: 'Recetas chilenas listas en menos de 15 minutos',
  value: '$4.990'
}, {
  icon: <Map className="w-6 h-6" strokeWidth={1.75} data-id="element-38" />,
  title: 'BONO 1: Mapa Fuego Cero del Súper',
  desc: 'Guía visual por pasillo — qué comprar y qué evitar',
  value: '$6.990',
  isBonus: true
}, {
  icon: <LifeBuoy className="w-6 h-6" strokeWidth={1.75} data-id="element-39" />,
  title: 'BONO 2: SOS Abdomen 24 Horas',
  desc: 'Protocolo de emergencia para desinflamarte antes de un evento',
  value: '$6.990',
  isBonus: true
}, {
  icon: <Coffee className="w-6 h-6" strokeWidth={1.75} data-id="element-40" />,
  title: 'BONO 3: La Once Inteligente',
  desc: '7 versiones de once chilena sin inflamación',
  value: '$8.990',
  isBonus: true
}];
const TOTAL_REAL = '$47.930';
const PRICE_TODAY = '$14.990';
export function Deliverables() {
  return <section className="py-12 md:py-14 bg-brand-cream" data-id="element-41">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-42">
        {/* Heading */}
        <div className="text-center mb-12" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy" data-id="element-44">
            Todo lo que recibes hoy
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto mt-5 rounded-full" data-id="element-45" />
        </div>

        {/* Editorial table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl shadow-lg border border-brand-navy/5 overflow-hidden" data-id="element-46">
          {/* Table header (desktop only) */}
          <div className="hidden md:grid grid-cols-[1fr_auto] gap-6 px-8 py-4 bg-brand-navy/[0.03] border-b border-brand-navy/10" data-id="element-47">
            <div className="text-xs font-bold tracking-widest uppercase text-brand-navy/60" data-id="element-48">
              Componente
            </div>
            <div className="text-xs font-bold tracking-widest uppercase text-brand-navy/60 text-right" data-id="element-49">
              Valor
            </div>
          </div>

          {/* Rows */}
          <ul className="divide-y divide-brand-navy/10" data-id="element-50">
            {items.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.06
          }} className={`relative grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-4 md:gap-6 px-5 sm:px-8 py-5 items-center hover:bg-brand-cream/40 transition-colors ${item.isBonus ? 'bg-brand-gold/[0.04]' : ''}`} data-id="element-51">
                {/* Bonus side ribbon */}
                {item.isBonus && <span className="absolute left-0 top-0 bottom-0 w-1 bg-brand-gold" data-id="element-52" />}

                {/* Icon */}
                <div className={`shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl ${item.isBonus ? 'bg-brand-gold/15 text-brand-gold' : 'bg-brand-navy/5 text-brand-navy'}`} data-id="element-53">
                  {item.icon}
                </div>

                {/* Title + description */}
                <div className="min-w-0" data-id="element-54">
                  <div className="flex flex-wrap items-center gap-2 mb-0.5" data-id="element-55">
                    <h3 className="font-bold text-brand-navy text-base sm:text-lg leading-snug" data-id="element-56">
                      {item.title}
                    </h3>
                    {item.isBonus && <span className="inline-flex items-center gap-1 bg-brand-gold text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full" data-id="element-57">
                        <Sparkles className="w-3 h-3" data-id="element-58" /> Bono
                      </span>}
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed" data-id="element-59">
                    {item.desc}
                  </p>
                </div>

                {/* Value */}
                <div className="md:text-right" data-id="element-60">
                  <span className="font-serif font-bold text-xl text-brand-navy" data-id="element-61">
                    {item.value}
                  </span>
                </div>
              </motion.li>)}
          </ul>

          {/* Totals */}
          <div className="border-t-2 border-brand-navy/10" data-id="element-62">
            {/* Total real (strikethrough) */}
            <div className="grid grid-cols-[1fr_auto] gap-4 px-5 sm:px-8 py-4 items-center bg-brand-cream/40" data-id="element-63">
              <span className="text-xs sm:text-sm font-bold uppercase tracking-wider text-brand-navy/60" data-id="element-64">
                Valor Real
              </span>
              <span className="font-serif font-bold text-xl text-gray-400 line-through" data-id="element-65">
                {TOTAL_REAL}
              </span>
            </div>

            {/* Your investment today */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.98
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3
          }} className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-2 sm:gap-4 px-5 sm:px-8 py-6 items-center bg-brand-navy text-brand-cream" data-id="element-66">
              <div className="flex items-center gap-2" data-id="element-67">
                <Sparkles className="w-5 h-5 text-brand-gold" data-id="element-68" />
                <span className="text-sm sm:text-base font-bold uppercase tracking-wider" data-id="element-69">
                  Tu inversión hoy
                </span>
              </div>
              <span className="font-serif font-bold text-3xl sm:text-4xl text-brand-gold" data-id="element-70">
                {PRICE_TODAY}
              </span>
            </motion.div>

            {/* CTA below price */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.4
          }} className="px-5 sm:px-8 py-6 bg-brand-navy" data-id="element-71">
              <Button checkout fullWidth className="text-base sm:text-lg py-5 shadow-xl shadow-brand-gold/30" data-id="element-72">
                ¡SÍ, QUIERO DESINFLAMAR MI ABDOMEN AHORA!
              </Button>
              <p className="text-center text-xs text-brand-cream/60 mt-3" data-id="element-73">
                Pago único · Acceso inmediato · Garantía 7 días
              </p>
            </motion.div>
          </div>
        </motion.div>

        {/* Sub note */}
        <p className="text-center text-sm text-brand-navy/60 mt-6 italic" data-id="element-74">
          Acceso inmediato. Descarga digital — sin envíos, sin esperas.
        </p>
      </div>
    </section>;
}